import {TypeSat} from 'topmeteo/general/constants';

const Prefix = TypeSat;

export const buildURL = ({language, regionID, productID, offset, index, resolution}) => (
    ['', language, regionID, Prefix, productID, offset, index, resolution, ''].map(String).join('/')
);
